import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import TodayIcon from '@material-ui/icons/Today';

import PerfectScrollbar from 'react-perfect-scrollbar';

import api from '../../../services/api';
import AlertInformation from 'components/AlertInformation/AlertInformation';


class EscalaList extends Component {

    state = {

        escalas: [],

        carregando: false,

        searchFilter: {
            datainicial: '',
            datafinal: '',
            status: 'T'
        },

        openAlert: false,
        messageAlert: ''
    };


    estilo = {

        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,

        filtros: {
            padding: 12,
            marginBottom: 15
        },

        titulo: {
            marginBottom: 15
        },

        statusProgramada: {
            fontWeight: 'bold'
        },

        statusExecucao: {
            fontWeight: 'bold'
        },

        statusFinalizada: {
            fontWeight: 'bold'
        },

        statusCancelada: {
            fontWeight: 'bold'
        }
    };


    async componentDidMount() {

        this.definirPeriodoInicial();

    }


    /* =========================================================
       DEFINE HOJE ATÉ +7 DIAS
       ========================================================= */

    definirPeriodoInicial = () => {

        const hoje = new Date();

        const dataInicial =
            hoje
                .toISOString()
                .substring(0, 10);


        const dataFinalDate =
            new Date(hoje);

        dataFinalDate.setDate(
            dataFinalDate.getDate() + 7
        );


        const dataFinal =
            dataFinalDate
                .toISOString()
                .substring(0, 10);


        this.setState(
            {
                searchFilter: {
                    ...this.state.searchFilter,
                    datainicial: dataInicial,
                    datafinal: dataFinal
                }
            },
            () => {
                this.loadEscalas();
            }
        );
    };


    /* =========================================================
       CARREGA ESCALAS
       ========================================================= */

    loadEscalas = async () => {

        try {

            this.setState({
                carregando: true
            });


            const codMotorista =
                sessionStorage.getItem(
                    'codMotorista'
                );


            if (
                !codMotorista ||
                Number(codMotorista) <= 0
            ) {

                this.handleOpenAlert(
                    'Usuário logado não está vinculado a um motorista.'
                );

                return;
            }


            const {
                datainicial,
                datafinal,
                status
            } = this.state.searchFilter;


            let params = '';


            if (datainicial) {

                params +=
                    `?datainicial=${datainicial}`;

            }


            if (datafinal) {

                params +=
                    `${params ? '&' : '?'}datafinal=${datafinal}`;

            }


            if (
                status &&
                status !== 'T'
            ) {

                params +=
                    `${params ? '&' : '?'}status=${status}`;

            }


            /*
             * API:
             *
             * GET
             * /escala/minhas/:codMotorista
             */
            const response =
                await api.get(
                    `/escala/minhas/${codMotorista}${params}`
                );


            /*
             * Aceita:
             *
             * { data: [] }
             *
             * ou diretamente:
             *
             * []
             */
            let lista = [];

            if (
                response.data &&
                Array.isArray(response.data.data)
            ) {

                lista = response.data.data;

            } else if (
                Array.isArray(response.data)
            ) {

                lista = response.data;

            }


            this.setState({
                escalas: lista
            });


        } catch (error) {

            console.error(
                'Erro ao carregar escalas:',
                error
            );

            this.handleOpenAlert(
                error.response?.data?.message ||
                'Erro ao carregar escalas.'
            );

        } finally {

            this.setState({
                carregando: false
            });

        }

    };


    /* =========================================================
       HOJE
       ========================================================= */

    pesquisarHoje = () => {

        const hoje =
            new Date()
                .toISOString()
                .substring(0, 10);


        this.setState(
            {
                searchFilter: {
                    ...this.state.searchFilter,
                    datainicial: hoje,
                    datafinal: hoje
                }
            },
            () => {

                this.loadEscalas();

            }
        );

    };


    /* =========================================================
       ALTERAÇÃO DOS FILTROS
       ========================================================= */

    OnChangeSearch = (event) => {

        const {
            name,
            value
        } = event.target;


        this.setState({

            searchFilter: {

                ...this.state.searchFilter,

                [name]: value

            }

        });

    };


    /* =========================================================
       LIMPAR FILTROS
       ========================================================= */

    LimpaFiltros = () => {

        this.setState(
            {
                searchFilter: {
                    datainicial: '',
                    datafinal: '',
                    status: 'T'
                }
            },
            () => {

                this.loadEscalas();

            }
        );

    };


    /* =========================================================
       ALERTA
       ========================================================= */

    handleOpenAlert = (message) => {

        this.setState({
            openAlert: true,
            messageAlert: message
        });

    };


    handleCloseAlert = () => {

        this.setState({
            openAlert: false
        });

    };


    /* =========================================================
       STATUS
       ========================================================= */

    descricaoStatus = (status) => {

        switch (status) {

            case 'P':
                return 'Programada';

            case 'E':
                return 'Em execução';

            case 'F':
                return 'Finalizada';

            case 'C':
                return 'Cancelada';

            default:
                return status || '';

        }

    };


    /* =========================================================
       DATA
       ========================================================= */

    formatarData = (data) => {

        if (!data)
            return '';


        const valor =
            String(data)
                .substring(0, 10);


        const partes =
            valor.split('-');


        if (partes.length !== 3)
            return data;


        return (
            partes[2] +
            '/' +
            partes[1] +
            '/' +
            partes[0]
        );

    };

    descricaoStatusEscala = (escala) => {

        if (!escala)
            return '';

        if (
            escala.statusitem === 'E' &&
            escala.ultimoapontamento === 'P'
        ) {
            return 'Em intervalo';
        }

        return this.descricaoStatus(
            escala.statusitem
        );

    };

    /* =========================================================
       FORMATA TEMPO EM MINUTOS
       ========================================================= */

    formatarMinutos = (totalMinutos) => {

        if (
            totalMinutos === null ||
            totalMinutos === undefined ||
            totalMinutos === ''
        ) {
            return '-';
        }

        const minutos =
            Number(totalMinutos);

        if (isNaN(minutos)) {
            return '-';
        }

        const horas =
            Math.floor(minutos / 60);

        const restoMinutos =
            minutos % 60;


        if (horas > 0 && restoMinutos > 0) {

            return `${horas}h ${restoMinutos}min`;

        }


        if (horas > 0) {

            return `${horas}h`;

        }


        return `${restoMinutos}min`;

    };
    render() {

        const {
            escalas,
            searchFilter,
            carregando
        } = this.state;


        return (

            <div style={this.estilo}>


                <Typography
                    variant="h5"
                    style={this.estilo.titulo}
                >
                    Minhas Escalas
                </Typography>


                <Paper
                    style={this.estilo.filtros}
                >


                    <Button
                        color="primary"
                        onClick={this.pesquisarHoje}
                    >

                        <TodayIcon
                            style={{
                                marginRight: 5
                            }}
                        />

                        Hoje

                    </Button>


                    <Input
                        type="date"
                        id="datainicial"
                        name="datainicial"
                        value={
                            searchFilter.datainicial
                        }
                        onChange={
                            this.OnChangeSearch
                        }
                        style={{
                            marginLeft: 20,
                            width: 160
                        }}
                    />


                    <Input
                        type="date"
                        id="datafinal"
                        name="datafinal"
                        value={
                            searchFilter.datafinal
                        }
                        onChange={
                            this.OnChangeSearch
                        }
                        style={{
                            marginLeft: 20,
                            width: 160
                        }}
                    />


                    <Select
                        id="status"
                        name="status"
                        value={
                            searchFilter.status
                        }
                        onChange={
                            this.OnChangeSearch
                        }
                        style={{
                            marginLeft: 20,
                            minWidth: 150
                        }}
                    >

                        <MenuItem value="T">
                            Todos
                        </MenuItem>

                        <MenuItem value="P">
                            Programadas
                        </MenuItem>

                        <MenuItem value="E">
                            Em execução
                        </MenuItem>

                        <MenuItem value="I">
                            Em intervalo
                        </MenuItem>

                        <MenuItem value="F">
                            Finalizadas
                        </MenuItem>

                        <MenuItem value="C">
                            Canceladas
                        </MenuItem>

                    </Select>

                    <Button
                        color="primary"
                        onClick={
                            this.loadEscalas
                        }
                    >

                        <SearchIcon />

                    </Button>


                    <Button
                        color="primary"
                        onClick={
                            this.LimpaFiltros
                        }
                    >

                        <ClearAllIcon />

                    </Button>


                </Paper>


                <Card>

                    <CardContent>

                        {carregando && (

                            <Typography>
                                Carregando escalas...
                            </Typography>

                        )}


                        {!carregando &&
                            escalas.length === 0 && (

                                <Typography>

                                    Nenhuma escala localizada
                                    para o período informado.

                                </Typography>

                            )
                        }


                        {!carregando &&
                            escalas.length > 0 && (

                                <PerfectScrollbar>

                                    <Table>

                                        <TableHead>

                                            <TableRow>

                                                <TableCell>
                                                    Data
                                                </TableCell>

                                                <TableCell>
                                                    Cliente / Obra
                                                </TableCell>

                                                <TableCell>
                                                    Serviço
                                                </TableCell>

                                                <TableCell>
                                                    Veículo
                                                </TableCell>

                                                <TableCell>
                                                    Status
                                                </TableCell>

                                                <TableCell>
                                                    Tempo
                                                </TableCell>

                                                <TableCell>
                                                    Ação
                                                </TableCell>
                                            </TableRow>

                                        </TableHead>


                                        <TableBody>

                                            {escalas.map(
                                                escala => (

                                                    <TableRow
                                                        hover
                                                        key={
                                                            escala.iditemescala
                                                        }
                                                    >

                                                        <TableCell>

                                                            {
                                                                this.formatarData(
                                                                    escala.data
                                                                )
                                                            }

                                                        </TableCell>


                                                        <TableCell>

                                                            <strong>

                                                                {
                                                                    escala.cliente ||
                                                                    escala.nomecliente ||
                                                                    ''
                                                                }

                                                            </strong>

                                                            <br />

                                                            {
                                                                escala.projeto ||
                                                                escala.descricaoprojeto ||
                                                                escala.descricao ||
                                                                ''
                                                            }

                                                        </TableCell>


                                                        <TableCell>

                                                            {
                                                                escala.servico ||
                                                                escala.descservico ||
                                                                ''
                                                            }

                                                        </TableCell>


                                                        <TableCell>

                                                            {
                                                                escala.veiculo ||
                                                                escala.descveiculo ||
                                                                ''
                                                            }

                                                        </TableCell>


                                                        <TableCell>
                                                            {
                                                                this.descricaoStatusEscala(
                                                                    escala
                                                                )
                                                            }

                                                        </TableCell>
                                                        <TableCell>

                                                            {
                                                                escala.statusitem === 'F'
                                                                    ? this.formatarMinutos(
                                                                        escala.totalminutostrabalhados
                                                                    )
                                                                    : '-'
                                                            }

                                                        </TableCell>


                                                        <TableCell>

                                                            <Link
                                                                to={
                                                                    `/front/escala/item/${escala.iditemescala}`
                                                                }
                                                            >

                                                                <PageviewOutlinedIcon
                                                                    style={{
                                                                        cursor:
                                                                            'pointer'
                                                                    }}
                                                                />

                                                            </Link>

                                                        </TableCell>

                                                    </TableRow>

                                                )
                                            )}

                                        </TableBody>

                                    </Table>

                                </PerfectScrollbar>

                            )
                        }

                    </CardContent>

                </Card>


                <AlertInformation

                    open={
                        this.state.openAlert
                    }

                    handleClose={
                        this.handleCloseAlert
                    }

                    message={
                        this.state.messageAlert
                    }

                />


            </div>
        );
    }
}


export default EscalaList;